import AbstractEntity from "./abstractEntity";

/*
franchiseObj properties:
  - id
  - abbr
  - city
  - nickname
  - slug
  - founder (username)
  - dateFounded
  - colors
  - roles
  - teams ({season: teamId})
 */
class Franchise extends AbstractEntity {
  // constructor(franchiseObj, userInfo) {
  //   super(franchiseObj, userInfo);
  // }

  /**
   *
   * @returns {object}
   */
  getRecentTeamObj() {
    if (!this.userInfo) return null;

    const seasons = Object.keys(this.obj.teams).map((seasonStr) =>
      parseInt("" + seasonStr, 10)
    );
    const recentSeason = Math.max(...seasons);
    return this.userInfo.getTeamObj(this.obj.teams[recentSeason]);
  }
}

export default Franchise;
